// src/utils/config.js

// L'adresse du backend Node.js en production (logique temps réel Socket.io & base de données MariaDB)
export const SERVER_URL = 'https://moteur.memozyn-quiz.ch';

// L'adresse du frontend Web en production (l'interface visuelle du jeu)
export const CLIENT_URL = 'https://memozyn-quiz.ch';